import { type PropsWithChildren } from "react";

import { AllergensLabeled } from "~/components/allergens";
import { type AllergenLanguageCode } from "~/components/allergens/constants";

type AllergensSectionProps = PropsWithChildren<{
  allergens: string[];
  languageCode: AllergenLanguageCode;
}>;

export const AllergensSection = ({
  allergens,
  languageCode,
  children
}: AllergensSectionProps) => {
  if (allergens.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      <p className="text-2xl font-semibold">{children}</p>

      <AllergensLabeled allergens={allergens} languageCode={languageCode} />
    </div>
  );
};
